
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CampaignLog {
  id: string;
  campaign_id: string;
  user_id: string | null;
  action_type: string;
  old_values: any;
  new_values: any;
  description: string | null;
  created_at: string;
}

export const useCampaignLogs = (campaignId?: string) => {
  return useQuery({
    queryKey: ['campaign-logs', campaignId],
    queryFn: async () => {
      if (!campaignId) return [];
      
      console.log('Fetching campaign logs for campaign:', campaignId);
      
      const { data, error } = await supabase
        .from('campaign_logs')
        .select('*')
        .eq('campaign_id', campaignId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching campaign logs:', error);
        throw error;
      }

      return data as CampaignLog[];
    },
    enabled: !!campaignId,
  });
};
